export default __webpack_public_path__ + "28325eb579f893ff16d3d795cb853c21.png";